var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "用户名称" },
                model: {
                  value: _vm.searchData.user_name,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "user_name", $$v)
                  },
                  expression: "searchData.user_name"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "角色名称" },
                model: {
                  value: _vm.searchData.role_name,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "role_name", $$v)
                  },
                  expression: "searchData.role_name"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "账号" },
                model: {
                  value: _vm.searchData.email,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "email", $$v)
                  },
                  expression: "searchData.email"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", filterable: "", placeholder: "状态" },
                  model: {
                    value: _vm.searchData.status,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "status", $$v)
                    },
                    expression: "searchData.status"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "正常", value: 1 } }),
                  _c("el-option", { attrs: { label: "禁用", value: 0 } })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "是否子账号"
                  },
                  model: {
                    value: _vm.searchData.son_account,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "son_account", $$v)
                    },
                    expression: "searchData.son_account"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "是", value: 1 } }),
                  _c("el-option", { attrs: { label: "否", value: 2 } })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getData(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20, type: "flex", justify: "start" } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "BTN",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleSource("t")
                    }
                  }
                },
                [_vm._v("添加用户")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "ones",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60" }
          }),
          _c("el-table-column", { attrs: { prop: "nickname", label: "昵称" } }),
          _c("el-table-column", { attrs: { prop: "email", label: "账号" } }),
          _c("el-table-column", {
            attrs: { prop: "auth_group_name", label: "角色名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tooltip",
                      { attrs: { effect: "dark", placement: "top" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: { display: "flex", cursor: "pointer" },
                            attrs: { slot: "content" },
                            slot: "content"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { "margin-right": "10px" },
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.roleGame.init(
                                      row.auth_group_id
                                    )
                                  }
                                }
                              },
                              [_vm._v("产品修改")]
                            ),
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.addRole.init(
                                      row.auth_group_id
                                    )
                                  }
                                }
                              },
                              [_vm._v("权限修改")]
                            )
                          ]
                        ),
                        _c("div", { staticStyle: { cursor: "pointer" } }, [
                          _vm._v(_vm._s(row.auth_group_name))
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "parent_name", label: "上级用户" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(row.parent_name == 0 ? "/" : row.parent_name) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.status == 0
                      ? _c("span", { staticClass: "statusTag1" }, [
                          _vm._v("禁用")
                        ])
                      : _vm._e(),
                    row.status == 1
                      ? _c("span", { staticClass: "statusTag2" }, [
                          _vm._v("正常")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "version", label: "当前版本" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "320",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "x-c" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "controlsBtn",
                            on: {
                              click: function($event) {
                                return _vm.$refs.rolead.init(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("广告权限")]
                        ),
                        _c("div", { staticClass: "controlsBtn-vertical" }),
                        _c(
                          "div",
                          {
                            staticClass: "controlsBtn",
                            on: {
                              click: function($event) {
                                return _vm.handleSource(scope.row.id, true)
                              }
                            }
                          },
                          [_vm._v("复制账号")]
                        ),
                        _c("div", { staticClass: "controlsBtn-vertical" }),
                        _c(
                          "el-popconfirm",
                          {
                            attrs: {
                              title:
                                "此操作将" +
                                (scope.row.status == 0 ? "启用" : "禁用") +
                                "该用户"
                            },
                            on: {
                              confirm: function($event) {
                                return _vm.handleDisable(scope.row.id)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                attrs: { slot: "reference" },
                                slot: "reference"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.status == 0 ? "启用" : "禁用"
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _c("div", { staticClass: "controlsBtn-vertical" }),
                        _c(
                          "div",
                          {
                            staticClass: "controlsBtn",
                            on: {
                              click: function($event) {
                                return _vm.handleSource(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("修改")]
                        ),
                        _c("div", { staticClass: "controlsBtn-vertical" }),
                        _c(
                          "div",
                          {
                            staticClass: "controlsBtn",
                            on: {
                              click: function($event) {
                                return _vm.handleDelete(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.searchData.page,
          total: _vm.total
        },
        on: { "size-change": _vm.sizeChange, "current-change": _vm.getData }
      }),
      _c("addUser", {
        ref: "addUser",
        attrs: { showing: _vm.showing },
        on: {
          changeShow: _vm.changeShow,
          refreshDataList: function($event) {
            return _vm.getData(_vm.searchData.page)
          }
        }
      }),
      _c("rolead", { ref: "rolead" }),
      _c("addRole", {
        ref: "addRole",
        attrs: { presentation: _vm.presentations, showing: _vm.showing },
        on: {
          changeShow: _vm.changeShow,
          refreshDataList: function($event) {
            return _vm.getData(_vm.searchData.page)
          }
        }
      }),
      _c("roleGame", { ref: "roleGame" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }